import { useContext, useMemo } from 'react';
import { EnumsContext } from '@core/components/src/XAppWrapper/withEnums/withEnums';
import { EnumsHookContext } from '@core/components';

export const useEnums = (enumName: string) => {
  const { enums } = useContext(EnumsContext);
  const { enumWrapperName } = useContext(EnumsHookContext);

  const selectedEnums = useMemo(() => {
    const enumsByWrapperName = enums[enumWrapperName || ''];

    if (!enumsByWrapperName) return [];

    return enumsByWrapperName[enumName];
  }, []);

  return selectedEnums;
};
